export default class StudioUpgradeTarget {

    public studioId: number;
    public allEligibleSamples: boolean = false;
    public macAddresses: string[] = [];
    public pilotSampleMacAddressOverride?: string;

    constructor(data: { [key: string]: any }) {
        this.studioId = data['studioId'];
        this.allEligibleSamples = data['allEligibleSamples'] ?? false;
        this.macAddresses = data['macAddresses'] || [];
        this.pilotSampleMacAddressOverride = data['pilotSampleMacAddressOverride'];
    }
}
